module.exports = __webpack_public_path__ + "static/img/logoFrogWhite.8cac215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logoFrogWhite.png
// module id = rDah
// module chunks = 1